/* eslint-disable @typescript-eslint/ban-types */
import { TextFieldProps } from '@mui/material';
import React from 'react';
import { Control, Controller, Path, RegisterOptions } from 'react-hook-form';

import Autocomplete, { AutocompleteProps } from '../Autocomplete/Autocomplete';

interface FormAutocompleteProps<T, D> {
  name: Path<T>;
  control: Control<T, object>;
  disabled?: boolean;
  className?: string;
  rules?: RegisterOptions;
  helperText?: string;
  error?: boolean;
  AutocompleteProps?: AutocompleteProps<D>;
  InputProps?: TextFieldProps;
}

export const FormAutocomplete = <T, D>({
  name,
  control,
  disabled = false,
  className,
  rules,
  helperText,
  error = false,
  AutocompleteProps,
  InputProps,
}: FormAutocompleteProps<T, D>): JSX.Element => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field, fieldState }) => {
      return (
        <Autocomplete
          {...AutocompleteProps}
          value={field.value as D}
          onChange={(_, v) => field.onChange(v)}
          InputProps={{
            ...InputProps,
            name,
            disabled,
            className,
            helperText: helperText || fieldState?.error?.message,
            error: error || !!fieldState?.error?.message,
          }}
        />
      );
    }}
  />
);
